import { useTheme } from "@mui/material/styles";

interface RedactProps {
  width?: number;
}

/**
 * Visual placeholder for anonymized text (e.g. a user's name in a marketing
 * roadmap example). Renders a grey gradient bar at the height of the
 * surrounding text. Decorative only — hidden from assistive tech.
 */
export function Redact({ width = 80 }: RedactProps) {
  const theme = useTheme();
  return (
    <span
      aria-hidden
      style={{
        display: "inline-block",
        width,
        height: "0.78em",
        background: `linear-gradient(90deg, ${theme.palette.background.default}, ${theme.palette.background.default})`,
        borderRadius: 2,
        verticalAlign: "middle",
        margin: "0 2px",
        boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
      }}
    />
  );
}

export default Redact;
